module.exports = __webpack_public_path__ + "img/advantage_three.0b188a86.png";